import { HierarchyManager } from "../../components/HierarchyManager";
import { directoryConfig } from "./directoryConfig";

function DirectoriesPage() {
  return <HierarchyManager config={directoryConfig} />;
}

export default DirectoriesPage;
